<template>
  <div>
    <PageAppBar>Stands</PageAppBar>
    <div v-if="!message" class="page-content header-clear-small">
      <div v-if="!Object.keys(stands).length">
        <mushonga color="#BF263C"></mushonga>
      </div>

      <div v-else v-for="stand in stands.data.data" :key="(stand.id)">
        <div>
          <div class="card card-style mb-3 ">
            <div class="d-flex">
              <div class="pl-3 ml-2">
                <h1 class="pt-4">{{ stand.project }}</h1>
                <p class="font-11 opacity-50 mt-n2 mb-2">Description: {{ stand.details }}</p>
                <p class="font-11 opacity-50 mt-n2 mb-2">Payment Interval: {{ stand.contribution_interval }}</p>
                <p class="font-11 opacity-50 mt-n2 mb-2">Duration: {{ stand.number_of_contributions }} {{ stand.contribution_interval }}s</p>
                <p @click="joinStandProject(stand)" class="font-11 opacity-50 mt-n2 mb-4">Join scheme</p>

              </div>
              <div class="ml-auto mr-4 align-self-center">
                <i @click="joinStandProject(stand)" class="fa fa-plus-circle pri-color fa-3x mt-4 mb-4"></i>
              </div>
            </div>
            <router-link :to="'/stand/'+stand.id"  class="btn btn-m btn-full mb-1 rounded-sm text-uppercase font-900 border-yellow yellow bg-theme">More Details</router-link>
          </div>
        </div>
      </div>
      <FooterBar></FooterBar>
    </div>
    <div v-else-if="message.length" class="page-content header-clear-small">
      <div v-if="message.length">
        {{message}}
      </div>
      <div class="card card-style">
        <div class="content">
          <h1>TBD STANDS</h1>
          <p class="color-highlight font-12 mt-n3 pt-1 mb-2">You have joined TSP{{$route.params.id}}</p>
          <p v-if="Object.keys(stand).length">To begin you have to start making your contributions of ${{stand.contribution_amount}}
            starting {{stand.start_date}} for {{stand.number_of_contributions}} {{stand.contribution_interval}}s </p>
        </div>
      </div>
      <FooterBar> </FooterBar>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex"
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";
import global from "@/mixins/global";
import axios from "axios";
export default {
  data(){
    return {
      stands: [],
      stand: {}
    }
  },
  mixins: [global],
  mounted() {
    axios.get(this.base_url+"stands", this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{this.stands = response}).catch(error=>{this.error = error})
  },
  components: {
    PageAppBar,
    FooterBar
  },
  name: "Stand.vue",
  methods: {
    ...mapMutations(["updateStand"]),
  },
}
</script>

<style scoped>

.pri-color{
  color: #DA4453;

}



</style>